import React from 'react';
import AnswerMarkdown from './AnswerMarkdown';
import QueryCitations from './QueryCitations';
import QueryDetailsButtons from './QueryDetailsButtons';

const QueryDetailsRegular = ({ query, onCitationClick, onAnswerCopy, onShare, protectedPage }) => {
  return (
    <div style={{ fontSize: '16px' }}>
      <AnswerMarkdown isCompleted={query.isCompleted()} onCitationClick={onCitationClick}>
        {query.getAnswer()}
      </AnswerMarkdown>
      {query.getCitations() && query.isCompleted() &&
        <QueryCitations citations={query.getCitations()} />}
      {query.isCompleted() && protectedPage && (
        <QueryDetailsButtons
          query={query}
          onAnswerCopy={onAnswerCopy}
          onShare={onShare}
        />
      )}
    </div>
  );
};

export default QueryDetailsRegular; 